const map = {
	"./README.md": 936,
	"./decisions/0001-minimum-amount-first-time-purchase-on-public-pages.md": 1,
	"./decisions/0002-app-first-frontend-structure.md": 458,
	"./decisions/0003-annual-cost-label-in-fund-list.md": 955,
	"./decisions/0004-rounding-amounts-in-savings-overview.md": 517,
	"./endpoints/get-transfer-share-savings-account-form-accounts.md": 771
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 608;